import React from 'react'
import OTOne from '../assets/images/Tile_OT-1.svg'
import OTTwo from '../assets/images/Tile_OT-2.svg'
import OTThree from '../assets/images/Tile_OT-3.svg'

const OTCards = () => {
  return (
    <div className="d-flex w-100 gap-4" style={{ padding: "0 0 15px 0" }}>
      <img src={OTOne} alt='OToneimage' />
      <img src={OTTwo} alt='OTtwoimage' />
      <img src={OTThree} alt='OTthreeimage' />
  </div>
  )
}

export default OTCards